import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading && _vm.message)?_c(VContainer,{staticClass:"pa-0"},[_c('a-alert',{attrs:{"message":_vm.message,"type":"info"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }